import { createFileRoute } from "@tanstack/react-router";
import { CrudTable } from "@/features/admin/components/CrudTable";

export const Route = createFileRoute("/_authenticated/admin/blog")({
  component: () => (
    <CrudTable
      title="Blog Posts"
      table="blog_posts"
      orderBy={{ column: "created_at" }}
      columns={[
        { key: "title", label: "Title" },
        { key: "slug", label: "Slug" },
        { key: "author_name", label: "Author" },
        { key: "is_published", label: "Published", render: (r) => (r.is_published ? "✅" : "❌") },
      ]}
      fields={[
        { key: "slug", label: "Slug (unique, e.g. best-age-to-learn)", required: true },
        { key: "title", label: "Title", required: true },
        { key: "excerpt", label: "Excerpt", type: "textarea" },
        { key: "content", label: "Content (markdown supported)", type: "textarea", required: true },
        { key: "cover_image_url", label: "Cover Image URL" },
        { key: "author_name", label: "Author Name" },
        { key: "is_published", label: "Published", type: "switch" },
      ]}
    />
  ),
});
